var map; //<-- This is now available to both event listeners and the initialize() function
var mapCenter; // Declare a variable to store the center of the map

var infoBox = false;

var exhlat = '54.679176';
var exhlng = '25.276102';

if ($('#map').hasClass('exh')) {
    exhlat = $('#map').data('lat');
    exhlng = $('#map').data('lng');
}

function initialize() {
    var mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: 13,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false,
        zoomControl: true,

        // The latitude and longitude to center the map (always required)
        //center: new google.maps.LatLng(55.894844, 23.362054), // center

        // How you would like to style the map.
        // This is where you would paste any style found on Snazzy Maps.
        styles: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "59"
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#021331"
                    },
                    {
                        "weight": "0"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#838b9a"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6e8eb"
                    },
                    {
                        "lightness": "62"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "100"
                    },
                    {
                        "saturation": "0"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "color": "#838b9a"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "weight": "0.01"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "80"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "80"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "80"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#838b9a"
                    },
                    {
                        "lightness": "60"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#2d75f9"
                    },
                    {
                        "lightness": "65"
                    },
                    {
                        "saturation": "-40"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616c81"
                    }
                ]
            }
        ]
    };

    mapCenter = new google.maps.LatLng(exhlat, exhlng);


    if ($('#map').length > 0) {
        map = new google.maps.Map(document.getElementById("map"), mapOptions);
        map.setCenter(mapCenter);
    }

    // centerMarker = new google.maps.Marker({
    //     position: new google.maps.LatLng(exhlat, exhlng),
    //     map: map,
    //     icon: image,
    //     title: ''
    // });


    //addMarkers();
}


var pin = 'https://emcy.org/wp-content/themes/emcy/assets/images/pin.png';
var markersArray = [];
var bounds = new google.maps.LatLngBounds();

function addMarkers(markers) {

    function setMapOnAll(map) {
        bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < markersArray.length; i++) {
            markersArray[i].setMap(map);
            bounds.extend(markersArray[i].getPosition());
        }
    }
    function clearMarkers() {
        setMapOnAll(null);
    }
    function showMarkers() {
        setMapOnAll(map);
    }
    function deleteMarkers() {
        clearMarkers();
        markersArray = [];
    }

    if (markers != '') {

        if (map === undefined) {
            initialize();

            setTimeout(function () {
                mrks()
            }, 1000)
        } else {
            mrks()
        }

        function mrks() {
            deleteMarkers();

            markers.forEach(function (el) {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(el.lat, el.lng),
                    map: map,
                    icon: pin,
                    title: el.title
                });

                markersArray.push(marker);
                initInfoWindow(marker, el);
            });

            showMarkers();

            map.fitBounds(bounds);
            var zoom = map.getZoom();
            map.setZoom(zoom > 10 ? 10 : zoom);
        }




    } else {

        deleteMarkers();
    }
}

function initInfoWindow (marker, el) {
    var self = this;

    google.maps.event.addListener(marker, "click", function (e) {

        if (infoBox)
            infoBox.setMap(null);
        infoBox = new InfoBox({latlng: marker.getPosition(), map: map, info: '' +
        '<span class="title">' + el.title + '</span>' +
        '<span class="date">' + el.date + '</span>' +
        '<span class="place">' + el.place + '</span>' +
        '<span class="instruments">' + el.instruments + '</span>' +
        '<a href="' + el.url  + '" class="url link">Read more</a>'});

    });

}

if ($('#map').length > 0) {
    google.maps.event.addDomListener(window, 'load', initialize);
}

function calculateJuryLetters() {
    $('.jury-grid .jury-item').each(function (index) {
        var letter = $(this).data('letter');

        if ($(this).is(':visible')) {
            var waypoint = new Waypoint.Inview({
                element: this,
                enter: function (direction) {
                    $('.jury-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                entered: function (direction) {
                    $('.jury-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                exit: function (direction) {
                    $('.jury-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                },
                exited: function (direction) {
                    $('.jury-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                }
            })
        }
    });
}
function calculatePwLetters() {
    $('.pw-grid .pw-item').each(function (index) {
        var letter = $(this).data('letter');

        if ($(this).is(':visible')) {
            var waypoint = new Waypoint.Inview({
                element: this,
                enter: function (direction) {
                    $('.pw-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                entered: function (direction) {
                    $('.pw-letters .letter[data-letter="' + letter + '"]').addClass('active');
                },
                exit: function (direction) {
                    $('.pw-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                },
                exited: function (direction) {
                    $('.pw-letters .letter[data-letter="' + letter + '"]').removeClass('active');
                }
            })
        }
    });
}

function accordionCalcs() {
    $('.accordion-line').removeClass('expanded').css('height', 'auto');

    $('.accordion-line').each(function () {
        var headHeight = $(this).find('.accordion-line-head').outerHeight(true);
        var bodyHeight = $(this).find('.accordion-line-body').outerHeight(true);
        $(this).css('height', headHeight).attr('data-all-height', headHeight + bodyHeight).attr('data-head-height', headHeight);
    });
}

var w = 0;

$(document).ready(function () {


    $('.search-wrap .search-toggle').on('click', function () {
        $(this).parent().addClass('active');
    });

    $('.search-wrap .search-submit').on('click', function () {
        if ($('.search-wrap .search-input input').val().length !== 0) {
            window.location = $(this).data('path') + '?keyword=' + $('.search-wrap .search-input input').val()
        } else {
            $('.search-wrap').removeClass('active');
        }
    });

    $('.search-wrap .search-input input').on('keyup', function () {
        var input = $(this);

        console.log(input.val().length);

        if (input.val().length === 0) {
            $('.search-wrap .search-results').html('');
            return;
        }

        var data = {
            'action' : 'get_search',
            'keyword' : input.val()
        };

        $.get(postemcy.ajax_url, data, function(response){

            if (response.success) {
                if (input.val().length !== 0) {
                    $('.search-wrap .search-results').html(response.data)
                }
            } else {
                if (input.val().length !== 0) {
                    $('.search-wrap .search-results').html('<div class="result-box no-results">No results found</div>')
                }
            }

        });
    });


    $('.sound-toggle').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');

            $('audio').each(function (ind, el) {
                el.muted = false;
            })
        } else {
            $(this).addClass('active');

            $('audio').each(function (ind, el) {
                el.muted = true;
            })
        }
    });

    var filterJury = $('.jury-filter select').select2({
        minimumResultsForSearch: Infinity
    });
    filterJury.on("select2:select", function (e) {
        var which = e.params.data.id;

        $('.jury-filter .clear').show();
        $('.jury-grid .jury-item').show();
        $('.jury-grid .jury-item:not(.' + which + ')').hide();
        $('.jury-letters .letter').removeClass('active');
        Waypoint.destroyAll();
        calculateJuryLetters();
    });

    $('.jury-filter .clear').on('click', function () {
        $('.jury-grid .jury-item').show();
        $('.jury-letters .letter').removeClass('active');
        Waypoint.destroyAll();
        calculateJuryLetters();
        $(this).hide();
        $('.jury-filter select').val('').trigger('change');
    });

    $('.jury-letters .letter').on('click', function () {
        var letter = $(this).data('letter');
        var to = $('.jury-grid .jury-item[data-letter=' + letter + ']').offset().top;

        $("html, body").animate({scrollTop: to - 100});
    });

    $('.jury-letters').stick_in_parent({offset_top: 0});

    $('.pw-letters .letter').on('click', function () {
        var letter = $(this).data('letter');
        var to = $('.pw-grid .pw-item[data-letter=' + letter + ']').offset().top;

        $("html, body").animate({scrollTop: to - 100});
    });


    // Prize winners

    var currIns = '';
    var currNat = '';
    var currCom = '';
    var currYea = '';
    var currInt = false;

    var currIns1, currIns2, currIns3;

    var filterIns1 = $('.top-filter .filter-instrument-1').select2({
        minimumResultsForSearch: Infinity
    });
    var filterIns2 = $('.top-filter .filter-instrument-2').select2({
        minimumResultsForSearch: Infinity
    });
    var filterIns3 = $('.top-filter .filter-instrument-3').select2({
        minimumResultsForSearch: Infinity
    });

    var filterNatSelect = $('.top-filter .natFilter').select2({
        minimumResultsForSearch: Infinity
    });
    var filterComSelect = $('.top-filter .comFilter').select2({
        minimumResultsForSearch: Infinity
    });
    var filterYeaSelect = $('.top-filter .yeaFilter').select2({
        minimumResultsForSearch: Infinity
    });

    filterIns1.on("select2:select", function (e) {
        currIns1 = e.params.data.id;
        currIns2 = '';
        currIns3 = '';
        currIns = [currIns1, currIns2, currIns3];

        $('.filter-instrument-2').next().hide();
        $('.filter-instrument-3').next().hide();

        $('.top-filter .clear').show();

        getPW(currIns, currNat, currCom, currYea);
        getSubCats(e.params.data.id, '1');
    });
    filterIns2.on("select2:select", function (e) {
        currIns2 = e.params.data.id;
        currIns3 = '';
        currIns = [currIns1, currIns2, currIns3];

        $('.filter-instrument-3').next().hide();

        $('.top-filter .clear').show();

        getPW(currIns, currNat, currCom, currYea);
        getSubCats(e.params.data.id, '2');
    });
    filterIns3.on("select2:select", function (e) {
        currIns3 = e.params.data.id;
        currIns = [currIns1, currIns2, currIns3];

        $('.top-filter .clear').show();

        getPW(currIns, currNat, currCom, currYea);
    });

    filterNatSelect.on("select2:select", function (e) {
        currNat = e.params.data.id;
        $('.pw-filter .clear').show();
        getPW(currIns, currNat, currCom, currYea);
    });
    filterComSelect.on("select2:select", function (e) {
        currCom = e.params.data.id;
        $('.pw-filter .clear').show();
        getPW(currIns, currNat, currCom, currYea);
    });
    filterYeaSelect.on("select2:select", function (e) {
        currYea = e.params.data.id;
        $('.pw-filter .clear').show();
        getPW(currIns, currNat, currCom, currYea);
    });

    
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    $('.pw-filter #ch1').on('click', function () {
        if ($(this).is(':checked')) {
            $('.pw-filter .clear').show();
            currInt = true;

            if (currIns === '' && currNat === '' && currCom === '' && currYea === '') {
                $('.pw-grid .pw-item').hide();
                $('.pw-grid .pw-item.fint-international').show();

                if ($('.pw-item:visible').length === 0) {
                    $('.no-pw').show();
                } else {
                    $('.no-pw').hide();
                }
            } else {
                getPW(currIns, currNat, currCom, currYea)
            }
        } else {
            currInt = false;
            if (currIns === '' && currNat === '' && currCom === '' && currYea === '') {
                $('.pw-filter .clear').hide();

                $('.pw-grid .pw-item').show();
                $('.pw-letters .letter').removeClass('active');

                Waypoint.destroyAll();
                calculatePwLetters();
            } else {
                getPW(currIns, currNat, currCom, currYea)
            }
        }
    });

    $('.pw-filter .clear').on('click', function () {
        $('.pw-grid .pw-item').show();
        $('.pw-letters .letter').removeClass('active');
        Waypoint.destroyAll();
        calculatePwLetters();
        $(this).hide();

        currIns = '';
        currNat = '';
        currCom = '';
        currYea = '';
        currInt = false;

        $('.no-pw').hide();

        $("#ch1").prop("checked", false);
        $('.pw-filter select').val('').trigger('change');

        $('.filter-instrument-2').next().hide();
        $('.filter-instrument-3').next().hide();
    });

    setTimeout(function () {
        $('.pw-letters').stick_in_parent({offset_top: 0});
        if ($(window).width() > 767) {
            $('.pw-filter').stick_in_parent({offset_top: 0});
        }
        calculatePwLetters();
    }, 1100);

    calculateJuryLetters();

    function getPW(currIns, currNat, currCom, currYea) {
        var data = {
            'action' : 'get_pw',
            'currIns' : currIns,
            'currNat' : currNat,
            'currCom' : currCom,
            'currYea' : currYea
        };

        $.get(postemcy.ajax_url, data, function(response){


            $('.pw-grid .pw-item').hide();

            $.each(response.data, function (ind, el) {
                if (currInt) {
                    $('.pw-grid .pw-item.fint-international.id-' + el).show();
                } else {
                    $('.pw-grid .pw-item.id-' + el).show();
                }
            });

            $('.pw-letters .letter').removeClass('active');

            if ($('.pw-item:visible').length === 0) {
                $('.no-pw').show();
            } else {
                $('.no-pw').hide();
            }

            Waypoint.destroyAll();
            calculatePwLetters();
        });
    }

    // --- //

    accordionCalcs();

    $('.accordion-line-head').on('click', function () {
        var el = $(this).parent();
        var headHeight = el.data('head-height');
        var allHeight = el.data('all-height');

        if (el.hasClass('expanded')) {
            el.removeClass('expanded');
            el.css('height', headHeight);
        } else {
            el.addClass('expanded');
            el.css('height', allHeight);
        }
    });


    $('.show-more').on('click', function () {
        $(this).hide();
        $('.on-show-more').show();
    });

    var $frame = $('.history-slider .frame');
    var $wrap  = $frame.parent();
    $frame.sly({
        horizontal: 1,
        itemNav: 'basic',
        smart: 1,
        activateOn: 'click',
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        scrollBar: $wrap.find('#scrollbar'),
        scrollBy: 0,
        speed: 300,
        elasticBounds: 1,
        dragHandle: 1,
        dynamicHandle: 0,
        clickBar: 1
    });

    $('.menu-trigger').on('click', function () {
        $('.menu').addClass('active');
        $('body').addClass('fixed');
    });
    $('.menu .close').on('click', function () {
        $('.menu').removeClass('active');
        $('body').removeClass('fixed');
    });

    $('.subscribe-call').on('click', function () {
        $('.subscribe-modal .form-success-sub').removeClass('active');
        $('.subscribe-modal').addClass('active');
        $('body').addClass('fixed');
    });

    $('.subscribe-modal, .subscribe-modal .close').on('click', function (e) {
        if (e.target === this) {
            $('.subscribe-modal').removeClass('active');
            $('body').removeClass('fixed');
        }
    });

    $('li.menu-item-has-children > a').on('click', function (e) {
        if (($(window).width() < 1200) && ($(window).width() >= 768)) {
            e.preventDefault();
        }
    });

    $("[data-fancybox]").fancybox({
        loop: true,
        margin : [100, 100],
        buttons : [
            'close'
        ],
        hash : false
    });

    if ($('body').hasClass('error404')) {
        $('.menu-trigger').addClass('dark')
    }

    if ($(this).scrollTop() > 0) {
        $('.logo-full').addClass('smaller');
    } else {
        $('.logo-full').removeClass('smaller');
    }

    var calh = '';
    if ($(window).width() < 1060) {
        calh = 'auto';
    }

    $('.co-calendar').fullCalendar({
        firstDay: 1,
        fixedWeekCount: false,
        aspectRatio: 1.8,
        height: calh,
        header: {
            left:   'title prev,next',
            center: '',
            right:  ''
        },
        eventClick: function(event) {
            if (event.url) {
                window.location(event.url);
                return false;
            }
        },
        windowResize: function(view) {
            if ($(window).width() < 1060) {
                $('.co-calendar').fullCalendar('option', 'height', 'auto');
            } else {
                $('.co-calendar').fullCalendar('option', 'height', '');
            }
        }
    });

    var age = '', instrument = '', international = '', type = '', country = '', held = [];
    var nextpage = 1;

    function getCO(age, instrument, international, type, held) {
        var data = {
            'action' : 'get_competitions',
            'next_page' : 1,
            'age' : age,
            'country' : country,
            'instrument' : instrument,
            'international' : international,
            'type' : type,
            'held' : held
        };
        $.get(postemcy.ajax_url, data, function(response){
            if (type === 'calendar') {
                $('.co-calendar').fullCalendar( 'removeEvents' );
                if (response.success) {
                    $('.co-calendar').fullCalendar( 'renderEvents', response.data, true );
                }
            } else if (type === 'map') {
                if (response.success) {
                    addMarkers(response.data);
                } else {
                    addMarkers('');
                }
            }
        });
    }


    var loadingCOlist = false;

    function getCOlist(age, instrument, international, type, held, nextpage) {
        loadingCOlist = true;

        var data = {
            'action' : 'get_competitions',
            'next_page' : nextpage,
            'age' : age,
            'country' : country,
            'instrument' : instrument,
            'international' : international,
            'type' : type,
            'held' : held
        };
        $.get(postemcy.ajax_url, data, function(response){
            if (type === 'list') {
                if (response.success) {
                    if (nextpage === 1) {
                        $('.section-co-page .news-grid').html('');
                    }
                    $('.section-co-page .news-grid').append( response.data.html );

                    if (response.data.next_page < 0) {
                        $('.link-wrap').hide();
                    } else {
                        $('.link-wrap').css('display', 'flex');
                    }

                    $('.anim-reveal-ajaxed').each(function (ind, el) {
                        new ScrollMagic.Scene({
                            triggerElement: el,
                            triggerHook: 0.85,
                            offset: 0
                        })
                            .on("start", function (event) {
                                var element = event.target.triggerElement();
                                setTimeout(function () {
                                    $(element).addClass('animating');
                                }, 400);
                            })
                            //.addIndicators() // add indicators (requires plugin)
                            .addTo(controller);
                    });

                    $('.link').each(function (ind, el) {
                        new ScrollMagic.Scene({
                            triggerElement: el,
                            triggerHook: 0.85,
                            offset: 0
                        })
                            .on("start", function (event) {
                                var element = event.target.triggerElement();
                                setTimeout(function () {
                                    $(element).addClass('animating');
                                }, 200);
                            })
                            //.addIndicators() // add indicators (requires plugin)
                            .addTo(controller);
                    });

                    loadingCOlist = false;
                } else {
                    $('.section-co-page .news-grid').html('<div class="nocomp">No competitions found</div>');
                    $('.link-wrap').hide();
                }
            }
        });
    }

    if ($('.co-filter').length > 0) {
        if ($('.co-calendar').length > 0) {
            type = 'calendar';
        }
        if ($('#map').length > 0) {
            type = 'map';
        }

        if ($('.news-grid').length > 0) {
            type = 'list';
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    }

    var filterCO1 = $('.co-filter .filter-age').select2({
        minimumResultsForSearch: Infinity
    });
    var filterCO2 = $('.co-filter .filter-instrument-1').select2({
        minimumResultsForSearch: Infinity
    });
    var filterCO2a = $('.co-filter .filter-instrument-2').select2({
        minimumResultsForSearch: Infinity
    });
    var filterCO2b = $('.co-filter .filter-instrument-3').select2({
        minimumResultsForSearch: Infinity
    });
    var filterCO3 = $('.co-filter .filter-country').select2({
        minimumResultsForSearch: Infinity
    });

    var instrument1, instrument2, instrument3;

    $('.filter-instrument-2').next().hide();
    $('.filter-instrument-3').next().hide();

    filterCO1.on("select2:select", function (e) {
        age = e.params.data.id;
        nextpage = 1;

        $('.co-filter .clear').show();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    });
    filterCO2.on("select2:select", function (e) {
        console.log('sel2')
        instrument1 = e.params.data.id;
        instrument2 = '';
        instrument3 = '';
        instrument = [instrument1, instrument2, instrument3];
        nextpage = 1;

        $('.filter-instrument-2').next().hide();
        $('.filter-instrument-3').next().hide();

        $('.co-filter .clear').show();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage);
        } else {
            getCO(age, instrument, international, type, held);
        }
        getSubCats(e.params.data.id, '1');
    });
    filterCO2a.on("select2:select", function (e) {
        instrument2 = e.params.data.id;
        instrument3 = '';
        instrument = [instrument1, instrument2, instrument3];
        nextpage = 1;

        $('.filter-instrument-3').next().hide();

        $('.co-filter .clear').show();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage);
        } else {
            getCO(age, instrument, international, type, held);
        }
        getSubCats(e.params.data.id, '2');
    });
    filterCO2b.on("select2:select", function (e) {
        instrument3 = e.params.data.id;
        instrument = [instrument1, instrument2, instrument3];
        nextpage = 1;

        $('.co-filter .clear').show();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage);
        } else {
            getCO(age, instrument, international, type, held);
        }
    });
    filterCO3.on("select2:select", function (e) {
        country = e.params.data.id;
        nextpage = 1;

        $('.co-filter .clear').show();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    });

    function getSubCats(id, filter) {
        var data = {
            'action' : 'get_subcats',
            'id' : id
        };
        $.post(postemcy.ajax_url, data, function(response){
            var array = JSON.parse(response);

            if (array.length !== 0) {
                if (filter === '1') {
                    $('.filter-instrument-2').html('<option value="">Instrument</option>');
                    $.each( array, function( key, value ) {
                        $('.filter-instrument-2').append('<option value="' + value.term_id + '">' + value.name + '</option>');
                    });
                    $('.filter-instrument-2').next().show();
                } else if (filter === '2') {
                    $('.filter-instrument-3').html('<option value="">Instrument</option>');
                    $.each( array, function( key, value ) {
                        $('.filter-instrument-3').append('<option value="' + value.term_id + '">' + value.name + '</option>');
                    });
                    $('.filter-instrument-3').next().show();
                }
            }
        });
    }

    $('.co-filter #ch1').on('click', function () {
        nextpage = 1;

        if ($(this).is(':checked')) {
            $('.co-filter .clear').show();
            international = 'true';
        } else {
            international = '';
            if (age === '' && instrument === '' && country === '' && held.length === 0) {
                $('.co-filter .clear').hide();
            }
        }

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    });

    $('.checkboxes-wrap input').on('click', function () {
        nextpage = 1;
        
        var heldName = $(this).data('held');

        if ($(this).is(':checked')) {
            $('.co-filter .clear').show();
            held.push(heldName);
        } else {
            held.splice(held.indexOf(heldName), 1);

            if (age === '' && instrument === '' && country === '' && held.length === 0) {
                $('.co-filter .clear').hide();
            }
        }

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    });

    $('.co-filter .clear').on('click', function () {
        nextpage = 1;
        $(this).hide();
        $('.co-filter select').val('').trigger('change');
        $("#ch1").prop("checked", false);

        $('.checkboxes-wrap input').prop("checked", false);

        age = '';
        instrument = '';
        international = '';
        country = '';
        held = [];

        $('.filter-instrument-2').next().hide();
        $('.filter-instrument-3').next().hide();

        if ($('.news-grid').length > 0) {
            getCOlist(age, instrument, international, type, held, nextpage)
        } else {
            getCO(age, instrument, international, type, held);
        }
    });

    $('.section-co-page .link-wrap').on('click', function (e) {
        e.preventDefault();

        if (loadingCOlist) return;
        nextpage = nextpage + 1;

        getCOlist(age, instrument, international, type, held, nextpage);
    });

    var controller = new ScrollMagic.Controller();

    $('.give-light').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.5,
            offset: -160,
            duration: $(el).outerHeight() + 160
        })
            .setClassToggle(".menu-trigger", "light") // add class toggle
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controller);
    });

    $('.give-light').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.08,
            offset: -160,
            duration: $(el).outerHeight() + 160
        })
            .setClassToggle(".search-wrap", "light") // add class toggle
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controller);
    });

    var nextnewspage = 1;
    var newscategory = '';
    function getNews(category, nextnewspage) {
        var data = {
            'action' : 'get_news',
            'next_page' : nextnewspage,
            'category' : category
        };
        $.get(postemcy.ajax_url, data, function(response){
            if (response.success) {
                if (nextnewspage === 1) {
                    $('.section-news-page .news-grid').html('');
                }
                $('.section-news-page .news-grid').append( response.data.html );

                if (response.data.next_page < 0) {
                    $('.link-wrap').hide();
                } else {
                    $('.link-wrap').css('display', 'flex');
                }

                $('.anim-reveal-ajaxed').each(function (ind, el) {
                    new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 0.85,
                        offset: 0
                    })
                        .on("start", function (event) {
                            var element = event.target.triggerElement();
                            setTimeout(function () {
                                $(element).addClass('animating');
                            }, 400);
                        })
                        //.addIndicators() // add indicators (requires plugin)
                        .addTo(controller);
                });

                $('.link').each(function (ind, el) {
                    new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 0.85,
                        offset: 0
                    })
                        .on("start", function (event) {
                            var element = event.target.triggerElement();
                            setTimeout(function () {
                                $(element).addClass('animating');
                            }, 200);
                        })
                        //.addIndicators() // add indicators (requires plugin)
                        .addTo(controller);
                });
            } else {
                $('.section-news-page .news-grid').html('<div class="nocomp">No news found</div>');
                $('.link-wrap').hide();
            }
        });
    }

    var filterNews = $('.news-filter select').select2({
        minimumResultsForSearch: Infinity
    });

    filterNews.on("select2:select", function (e) {
        var which = e.params.data.id;

        $('.news-filter .clear').show();

        newscategory = which;
        nextnewspage = 1;

        getNews(newscategory, nextnewspage);
    });

    $('.find-out').on('click', function () {
        $('html, body').animate({
            scrollTop: $('body').find('.section-hero').outerHeight()
        }, 1000);
    });

    $('.news-filter .clear').on('click', function () {
        newscategory = '';
        nextnewspage = 1;

        $(this).hide();
        $('.news-filter select').val('').trigger('change');

        getNews(newscategory, nextnewspage);
    });

    $('.section-news-page:not(.section-projects) .link-wrap').on('click', function (e) {
        e.preventDefault();
        nextnewspage = nextnewspage + 1;

        getNews(newscategory, nextnewspage);
    });

    if ($('.news-filter').length > 0) {
        getNews(newscategory, nextnewspage);
    }

    $('.section-news-inner .social.facebook').on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');

        FB.ui({
            method: 'share',
            href: window.location.href
        }, function(response){});
    });



    var nextprojectspage = 1;
    var projectstype = '';
    function getProjects(projectstype, nextprojectspage) {
        var data = {
            'action' : 'get_projects',
            'next_page' : nextprojectspage,
            'type' : projectstype
        };
        $.get(postemcy.ajax_url, data, function(response){
            if (response.success) {
                if (nextprojectspage === 1) {
                    $('.section-news-page.section-projects .projects-grid').html('');
                }
                $('.section-news-page.section-projects .projects-grid').append( response.data.html );

                if (response.data.next_page < 0) {
                    $('.link-wrap').hide();
                } else {
                    $('.link-wrap').css('display', 'flex');
                }

                $('.anim-reveal-ajaxed').each(function (ind, el) {
                    new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 0.85,
                        offset: 0
                    })
                        .on("start", function (event) {
                            var element = event.target.triggerElement();
                            var delay = $(element).data('delay');
                            setTimeout(function () {
                                $(element).addClass('animating');
                            }, delay);
                        })
                        //.addIndicators() // add indicators (requires plugin)
                        .addTo(controller);
                });

                $('.link').each(function (ind, el) {
                    new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 0.85,
                        offset: 0
                    })
                        .on("start", function (event) {
                            var element = event.target.triggerElement();
                            setTimeout(function () {
                                $(element).addClass('animating');
                            }, 200);
                        })
                        //.addIndicators() // add indicators (requires plugin)
                        .addTo(controller);
                });
            } else {
                $('.section-news-page.section-projects .projects-grid').html('<div class="nocomp">No projects found</div>');
                $('.link-wrap').hide();
            }
        });
    }

    var filterProjects = $('.projects-filter select').select2({
        minimumResultsForSearch: Infinity
    });
    filterProjects.on("select2:select", function (e) {
        var which = e.params.data.id;

        $('.projects-filter .clear').show();

        projectstype = which;
        nextprojectspage = 1;

        getProjects(projectstype, nextprojectspage);
    });

    $('.projects-filter .clear').on('click', function () {
        projectstype = '';
        nextprojectspage = 1;

        $(this).hide();
        $('.projects-filter select').val('').trigger('change');
        getProjects(projectstype, nextprojectspage);
    });

    $('.section-news-page.section-projects .link-wrap').on('click', function (e) {
        e.preventDefault();
        nextprojectspage = nextprojectspage + 1;

        getProjects(projectstype, nextprojectspage);
    });

    if ($('.projects-filter').length > 0) {
        getProjects(projectstype, nextprojectspage);
    }

    $('.fake-submit').on('click', function () {
        $('.tosubmt').click();
    });

    $('.fake-submit-sub').on('click', function () {
        $('.subsubmt').click();
    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $('.newsletter form').on('submit', function (e) {
        $('#Email').removeClass('invalid');

        if (!validateEmail($('#Email').val())) {
            e.preventDefault();
            $('#Email').addClass('invalid');
        } else {
            $('.success').addClass('active');
        }
    });

    // 1st
    $('.tab-general .link').on('click', function () {
        $('.tab-general .required').removeClass('error');

        $('.tab-general .required').each(function (ind, el) {

            if ($(el).hasClass('email')) {
                if (!validateEmail($(el).val())) {
                    $(el).addClass('error');

                    $('html, body').animate({
                        scrollTop: $('body').find('.tab-general .required.error').offset().top - 50
                    }, 1000);
                }
            } else {
                if ($(el).val() === '') {
                    $(el).addClass('error');

                    $('html, body').animate({
                        scrollTop: $('body').find('.tab-general .required.error').offset().top - 50
                    }, 1000);
                }
            }
        });

        if (!$('body').find('.tab-general .required').hasClass('error')) {
            $('.form-tab').removeClass('active');
            $('.tab-details').addClass('active');

            $('.form-step').removeClass('active');
            $('.step-details').addClass('active');

            $('html, body').animate({
                scrollTop: $(".section-become").offset().top
            }, 1000);
        }
    });

    // 2nd
    $('.tab-details .link').on('click', function () {
        $('.form-tab').removeClass('active');
        $('.tab-previous').addClass('active');

        $('.form-step').removeClass('active');
        $('.step-previous').addClass('active');

        $('html, body').animate({
            scrollTop: $(".section-become").offset().top
        }, 1000);
    });

    // 3rd
    $('.tab-previous .link').on('click', function () {
        $('.form-tab').removeClass('active');
        $('.tab-further').addClass('active');

        $('.form-step').removeClass('active');
        $('.step-further').addClass('active');

        $('html, body').animate({
            scrollTop: $(".section-become").offset().top
        }, 1000);
    });

    // 4th
    $('.tab-further .link').on('click', function () {



        // inputs sync
        $('.competition-name').val($('#competition-name').val());
        $('.responsible-body').val($('#responsible-body').val());
        $('input[name=type-of-competition][value=' + $('input[name=toc]:checked').val() + ']').click();
        $('.chairman-president').val($('#chairman-president').val());
        $('.manager').val($('#manager').val());
        $('.contact-person').val($('#contact-person').val());
        $('.postal-address').val($('#postal-address').val());
        $('.email-address').val($('#email-address').val());
        $('.website').val($('#website').val());
        $('.phone-number').val($('#phone-number').val());
        $('.fax-number').val($('#fax-number').val());
        $('.year-of-foundation').val($('#year-of-foundation').val());
        var nor1 = $('input[name="number-of-rounds[]"]')[0];
        var nor2 = $('input[name="number-of-rounds[]"]')[1];
        var nor3 = $('input[name="number-of-rounds[]"]')[2];
        if ($('#number-of-round-1').is(':checked')) { $(nor1).attr('checked', true); }
        else { $(nor1).attr('checked', false); }
        if ($('#number-of-round-2').is(':checked')) { $(nor2).attr('checked', true); }
        else { $(nor2).attr('checked', false); }
        if ($('#number-of-round-3').is(':checked')) { $(nor3).attr('checked', true); }
        else { $(nor3).attr('checked', false); }

        $('.instruments').val($('#instruments').val());
        $('.age-groups').val($('#age-groups').val());
        $('.solo-categories').val($('#solo-categories').val());
        $('.ensemble-categories').val($('#ensemble-categories').val());

        $('input[name=Cyclicity][value="' + $('input[name=cradio]:checked').val() + '"]').click();
        $('input[name="origin-of-participants"][value="' + $('input[name=originradio]:checked').val() + '"]').click();

        var pay1 = $('input[name="must-the-candidate-pay[]"]')[0];
        var pay2 = $('input[name="must-the-candidate-pay[]"]')[1];
        var pay3 = $('input[name="must-the-candidate-pay[]"]')[2];
        if ($('#pay-1').is(':checked')) { $(pay1).attr('checked', true); }
        else { $(pay1).attr('checked', false); }
        if ($('#pay-2').is(':checked')) { $(pay2).attr('checked', true); }
        else { $(pay2).attr('checked', false); }
        if ($('#pay-3').is(':checked')) { $(pay3).attr('checked', true); }
        else { $(pay3).attr('checked', false); }

        var fin1 = $('input[name="the-competition-is-financed-by[]"]')[0];
        var fin2 = $('input[name="the-competition-is-financed-by[]"]')[1];
        var fin3 = $('input[name="the-competition-is-financed-by[]"]')[2];
        var fin4 = $('input[name="the-competition-is-financed-by[]"]')[3];
        var fin5 = $('input[name="the-competition-is-financed-by[]"]')[4];
        var fin6 = $('input[name="the-competition-is-financed-by[]"]')[5];
        if ($('#financed-1').is(':checked')) { $(fin1).attr('checked', true); }
        else { $(fin1).attr('checked', false); }
        if ($('#financed-2').is(':checked')) { $(fin2).attr('checked', true); }
        else { $(fin2).attr('checked', false); }
        if ($('#financed-3').is(':checked')) { $(fin3).attr('checked', true); }
        else { $(fin3).attr('checked', false); }
        if ($('#financed-4').is(':checked')) { $(fin4).attr('checked', true); }
        else { $(fin4).attr('checked', false); }
        if ($('#financed-5').is(':checked')) { $(fin5).attr('checked', true); }
        else { $(fin5).attr('checked', false); }
        if ($('#financed-6').is(':checked')) { $(fin6).attr('checked', true); }
        else { $(fin6).attr('checked', false); }
        $('.date-1').val($('#date-1').val());
        $('.date-2').val($('#date-2').val());
        $('.number-of-participants-1').val($('#number-of-participants-1').val());
        $('.number-of-participants-2').val($('#number-of-participants-2').val());
        $('.nationalities-of-participants-1').val($('#nationalities-of-participants-1').val());
        $('.nationalities-of-participants-2').val($('#nationalities-of-participants-2').val());
        $('.jury-1').val($('#jury-1').val());
        $('.jury-2').val($('#jury-2').val());
        $('.prizes-1').val($('#prizes-1').val());
        $('.prizes-2').val($('#prizes-2').val());
        $('.other-prizes-1').val($('#other-prizes-1').val());
        $('.other-prizes-2').val($('#other-prizes-2').val());
        $('.further-remarks').val($('#further-remarks').val());

        $('.submit-wpcf7').click();

        $('html, body').animate({
            scrollTop: $(".section-become").offset().top
        }, 1000);
    });



    $('.stt').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });









});

$(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
        $('.logo-full').addClass('smaller');
    } else {
        $('.logo-full').removeClass('smaller');
    }


    if ($(this).scrollTop() > $(window).height()) {
        $('.stt').addClass('active');
    } else {
        $('.stt').removeClass('active');
    }
});

$(window).on('resize', function () {
    if (w !== $(window).width()) {
        accordionCalcs();
        calculateJuryLetters();
        w = $(window).width();
    }
});
